var _path, _path2, _path3, _g, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 323.868,
    height: 155.082,
    viewBox: "0 0 323.868 155.082",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3",
    "data-name": "Trac\\xE9 3",
    d: "M1417.128,1.5H1570.71V155.082",
    transform: "translate(-1248.342 0)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "_4k",
    "data-name": "4k",
    d: "M1316.625,57.087H1293.1a3.372,3.372,0,0,0-3.362,3.361v23.53a3.361,3.361,0,0,0,3.362,3.361h23.529a3.371,3.371,0,0,0,3.361-3.361V60.448a3.361,3.361,0,0,0-3.361-3.361m0,26.891H1293.1V60.449h23.529Zm-15.966-6.723h2.521v-2.5h1.68V72.213h-1.68V67.171h-2.521v5.042h-2.521V67.171h-2.521v7.563h5.042Zm14.621,0-3.361-5.042,3.361-5.042h-2.857l-3.361,5.042,3.361,5.042Zm-6.218-5.042V67.171h-2.521V77.255h2.521Z",
    transform: "translate(-1248.342 0)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "hd",
    d: "M1275.232,57.088H1251.7a3.361,3.361,0,0,0-3.361,3.361V83.978a3.361,3.361,0,0,0,3.361,3.361h23.529a3.371,3.371,0,0,0,3.362-3.361V60.449a3.371,3.371,0,0,0-3.362-3.361m-13.445,20.167h-2.521V73.894h-3.361v3.361h-2.521V67.171h2.521v4.2h3.361v-4.2h2.521Zm3.361-10.084h6.723a1.687,1.687,0,0,1,1.681,1.681v6.723a1.686,1.686,0,0,1-1.681,1.68h-6.723Zm2.521,7.563h3.361V69.692h-3.361Z",
    transform: "translate(-1248.342 0)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "baterie",
    transform: "translate(-1248.342 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7",
    "data-name": "Trac\\xE9 7",
    d: "M1462.562,57.087a4.043,4.043,0,0,0-4.025,4.023v5.053h-6.05v12.1h6.05v5.052a4.043,4.043,0,0,0,4.025,4.024h11.1V57.087Z",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8",
    "data-name": "Trac\\xE9 8",
    d: "M1473.664,87.338h35.3a4.041,4.041,0,0,0,4.023-4.023V61.14a4.047,4.047,0,0,0-4.023-4.054h-35.3Z",
    fill: "#fff"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_25_FPS",
    "data-name": "25 FPS",
    transform: "translate(87.255 77.137)",
    fill: "#fff",
    fontSize: 28.243,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "25 FPS"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRight);
export default __webpack_public_path__ + "static/media/top_right.b39be4b4.svg";
export { ForwardRef as ReactComponent };